/**
 * Application constants for the Outlook add-in
 */

// Custom properties keys for storing booking metadata in Outlook items
export const CUSTOM_PROPERTIES = {
  BOOKING_ID: "deskare_booking_id",
  ROOM_ID: "deskare_room_id",
} as const;

// API configuration
export const API_CONFIG = {
  BASE_URL: process.env.VITE_API_URL || "",
  TIMEOUT_MS: 10000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY_MS: 1000,
} as const;

// Auto-dismiss timers
export const UI_TIMERS = {
  ERROR_AUTO_DISMISS_MS: 10000,
  SUCCESS_AUTO_DISMISS_MS: 5000,
} as const;
